module.exports = __webpack_public_path__ + "img/Java.4eb1819d.png";